import * as R from 'Router/routes';
import {
  PHONE,
  PHONE_BUNDLE,
  PHONE_BUNDLE_LINK,
  PHONE_LINK,
  PHONE_ONLINE,
  PHONE_ONLINE_LINK,
  PHONE_OVERDUE,
  PHONE_OVERDUE_LINK,
} from 'utils/constants';
import { useActiveLoan } from 'pages/ActiveLoan/useActiveLoan';
import useBundle from 'hooks/useBundle';

export function usePhone() {
  const { isOverdue } = useActiveLoan();
  const { isBundleAccepted } = useBundle();

  let phone: string = PHONE;
  let phoneLink: string = PHONE_LINK;

  if (window.location.pathname === R.ONLINE_LOGIN) {
    phone = PHONE_ONLINE;
    phoneLink = PHONE_ONLINE_LINK;
  } else if (isOverdue) {
    phone = PHONE_OVERDUE;
    phoneLink = PHONE_OVERDUE_LINK;
  } else if (isBundleAccepted) {
    phone = PHONE_BUNDLE;
    phoneLink = PHONE_BUNDLE_LINK;
  }

  const phoneNoSpaces = phone.replaceAll(' ', '');

  return {
    phone,
    phoneLink,
    phoneNoSpaces,
  };
}
